import { TaskCategory } from '@sib/api';
import { categoryIconMap, useTranslateCategory } from './CategorySelect.utils';

export interface TaskCategorySelectItemProps {
  label: TaskCategory;
}
export const TaskCategorySelectItem = ({
  label,
}: TaskCategorySelectItemProps) => {
  const translateCategory = useTranslateCategory();
  const Icon = categoryIconMap?.[label || TaskCategory.Other];

  return (
    <span
      className={
        'inline-flex items-center gap-1 [&_svg]:size-3 [&_svg]:shrink-0'
      }
    >
      {Icon && <Icon />}
      {translateCategory(label)}
    </span>
  );
};
